import styled from 'styled-components';
import * as GStyled from '../../../styles/components';

const ClearRuleButton = styled(GStyled.LinkButton)`
  margin-left: auto;
`;

export { ClearRuleButton };
